import * as React from 'react';
import { GenEntDataGrid } from '../components/GenEntDataGrid';
import { KeldomAlertDialog } from '../components/KeldomAlertDialog';

export function EditGenEntOnDeJob({
  deJobId,
  currentGenEnt,
}: {
  deJobId?: number;
  currentGenEnt?: number;
}) {
  const [selectedElement, setSelectedElement] = React.useState<number | null>(
    null,
  );

  const handleChangeCodeClient = async () => {
    //TODO: make it relative!
    await fetch('/api/edit-job/', {
      method: 'POST',
      body: JSON.stringify({ idDeJob: deJobId, genEnt: selectedElement }),
    });
    window.location.reload();
  };

  return (
    <KeldomAlertDialog
      title={"Edition de l'entreprise de l'offre " + deJobId}
      onValidate={handleChangeCodeClient}
      validateDisabled={
        !selectedElement || selectedElement === currentGenEnt
      }
    >
      <GenEntDataGrid
        currentCustomerId={currentGenEnt}
        setSelectedClient={setSelectedElement}
      />
    </KeldomAlertDialog>
  );
}
